import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { LoginService } from '../../service/login.service';
import { MensagemService } from '../../service/mensagem.service';
import { Helper } from '../../shared/Helper';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  @ViewChild('txtSenha') txtSenha: ElementRef;
  @ViewChild('txtEmail') txtEmail: ElementRef;
  @ViewChild('txtChave') txtChave: ElementRef;
  @ViewChild('txtCadSenha') txtCadSenha: ElementRef;
  @ViewChild('txtCpfCnpj') txtCpfCnpj: ElementRef;
  @ViewChild('txtCpfCnpjSolicitar') txtCpfCnpjSolicitar: ElementRef;
  @ViewChild('txtCpfCnpjCadastrar') txtCpfCnpjCadastrar: ElementRef;


  public senha = '';
  public chaveAcesso = '';
  public cpfCnpj = '';
  public desabilitado: boolean = false;
  public chaveSolicitada: boolean = false;
  public esqueceusenha: boolean = false;
  private _loginChaveSolicitar: string;
  public nomeCliente = "";
  public loginDuplicado = false;

  get loginChaveSolicitar():string{
    return this._loginChaveSolicitar;
  }
  set loginChaveSolicitar(value)
  {
    this._loginChaveSolicitar = value;
    this.cpfCnpj = '';
    this.localizarLogin();    
  }

  constructor(private loginService: LoginService,
    private msg: MensagemService, private router: Router) { }

  ngOnInit() {
  }

  public emailKeyUp(event) {
    if (event.key === "Enter") {
      if (this.loginDuplicado) {
        this.focarCpfCnpjLogin();
      }
      else {
        this.txtSenha.nativeElement.focus();
      }
    }
  }
  public CodigoKeyUp(event) {
    if (event.key === "Enter") {
      if (this.loginDuplicado) {
        this.focarCpfCnpjSolicitar();
      }
      else {
        this.SolicitarChave();
      }
    }
  }

  onLoginKey(event: any) { // without type info
    if (event.key === "Enter") {
      this.Logar();
    }
  }

  onCpfCnpjKey(event: any) {
    if (event.key === "Enter") {
      this.txtSenha.nativeElement.focus();
    }
  }

  onCpfCnpjSolicitarKey(event: any) {
    if (event.key === "Enter") {
      this.SolicitarChave();
    }
  }

  onCpfCnpjCadastrarKey(event: any) {
    if (event.key === "Enter") {
      this.txtChave.nativeElement.focus();
    }
  }

  chaveKeyUp(event: any) {
    if (event.key === "Enter") {
      this.txtCadSenha.nativeElement.focus();
    }
  }

  GerarCodigoKeyUp(event: any) {
    if (event.key === "Enter") {
      if (this.loginDuplicado) {
        this.focarCpfCnpjCadastrar();
      }
      else {
        this.txtChave.nativeElement.focus();
      }
    }
  }

  Cadastrar() {
    if (this.loginChaveSolicitar) {
      if (this.chaveAcesso) {
        if (this.senha) {
          if (this.loginDuplicado && !this.cpfCnpj) {
            this.msg.Aviso("CPF/CNPJ deve ser informado!");
            this.focarCpfCnpjCadastrar();
            return;
          }
          this.loginService.Cadastrar(this.loginChaveSolicitar, this.chaveAcesso, this.senha, this.cpfCnpj).subscribe(c => {
            if (c.sucesso) {
              this.loginChaveSolicitar = "";
              this.chaveAcesso = "";
              this.senha = "";
              this.cpfCnpj = '';
              this.msg.Aviso("Senha cadastrada com sucesso!");
            }
            else {
              this.msg.Aviso(c.msg);
            }
          })
        }
        else {
          this.msg.Aviso("Nova senha deve ser informada!");
        }
      }
      else {
        this.msg.Aviso("Chave de acesso deve ser informada!")
      }
    }
    else {
      this.msg.Aviso("Login deve ser informado!");
    }
  }

  onCadLoginKey(event: any) {
    if (event.key === "Enter") {
      this.Cadastrar();
    }
  }

  get loginChaveSolicitarValido():boolean
  {
    var rt = false;
    if (this.loginChaveSolicitar && this.loginChaveSolicitar.length >= 6)
    {
      rt = true;
    }
    return rt;
  }

  public localizarLogin(){
      if (this.loginChaveSolicitarValido)
      {
        this.loginService.LocalizarLogin(this.loginChaveSolicitar).subscribe(u=>
          {
            this.loginDuplicado = u.loginDuplicado;
            if (u.nome)
            {
            this.nomeCliente = u.nome;
            }
            else
            {
              this.nomeCliente = "Cliente não localizado!"
            }
          })
      }
      else
      {
        this.nomeCliente = "";
        this.loginDuplicado = false;
      }
  }

  public SolicitarChave() {
    if (this.loginChaveSolicitar) {
      if (this.loginDuplicado && !this.cpfCnpj) {
        this.msg.Aviso("CPF/CNPJ deve ser informado!");
        this.focarCpfCnpjSolicitar();
        return;
      }
      this.loginService.SolicitarChave(this.loginChaveSolicitar, this.cpfCnpj).subscribe(c => {
        if (c.sucesso) {
          this.chaveSolicitada = true;
        }
        else {
          this.msg.Aviso("Acesso já está ativo!");
        }
      });
    }
    else {
      this.msg.Aviso("Código deve ser informado")
    }
  }

  private redirect() {
    Helper.NavToDashboard(this.router);
  }

  private focarCpfCnpjLogin() {
    this.focarCampo(this.txtCpfCnpj);
  }

  private focarCpfCnpjSolicitar() {
    this.focarCampo(this.txtCpfCnpjSolicitar);
  }

  private focarCpfCnpjCadastrar() {
    this.focarCampo(this.txtCpfCnpjCadastrar);
  }

  private focarCampo(campo: ElementRef) {
    if (campo && campo.nativeElement) {
      campo.nativeElement.focus();
    }
  }

  public EsqueciSenha() {
    this.esqueceusenha = true;
  }

  public CancelarEsqueciSenha() {
    this.esqueceusenha = false;
  }

  public solicitarNovaSenha() {
    if (this.loginChaveSolicitar) {
      this.loginService.EsqueciSenha(this.loginChaveSolicitar).subscribe(s => {
        this.msg.Aviso(s.msg);
        this.esqueceusenha = false;
      });
    }
    else {
      this.msg.Aviso("Login deve ser informado!")
    }
  }

  public Logar() {
    if ((this.loginChaveSolicitar) && (this.senha)) {
      this.desabilitado = true;
      if (this.loginDuplicado && !this.cpfCnpj) {
        this.desabilitado = false;
        this.msg.Aviso('Por favor, informe o CPF/CNPJ');
        this.focarCpfCnpjLogin();
        return;
      }
      this.loginService.Logar(this.loginChaveSolicitar, this.senha, this.cpfCnpj).subscribe(rt => {
        let token = rt.token;
        if (token) {
          this.loginService.Usuario = "";
          this.loginService.Logado = true;
          localStorage.setItem("jwt", JSON.stringify(rt));
          this.redirect();
        }
        else {
          this.desabilitado = false;
          this.msg.Aviso('Usuário ou senha inválido!');
          this.loginChaveSolicitar = "";
          this.senha = "";
          this.cpfCnpj = '';
          var that = this;
          setTimeout(function () { that.txtEmail.nativeElement.focus(); }, 800);
        }
      });
    }
    else {
      this.msg.Aviso('Por favor, informe seu usuário e senha');
      this.txtEmail.nativeElement.focus();
    }
  }

}
